import { useCallback, useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

export type TripPlannerChatSearchParams = {
  chatId?: string;
  userId?: string;
};

function sanitizeSearchValue(value?: string | null) {
  const trimmedValue = value?.trim();

  return trimmedValue ? trimmedValue : undefined;
}

export function useTripPlannerChatSearchParams() {
  const history = useHistory();
  const location = useLocation();

  const searchParams = useMemo<TripPlannerChatSearchParams>(() => {
    const params = new URLSearchParams(location.search);

    return {
      chatId: sanitizeSearchValue(params.get('chatId')),
      userId: sanitizeSearchValue(params.get('userId')),
    };
  }, [location.search]);

  const updateSearchParams = useCallback(
    (nextSearchParams: TripPlannerChatSearchParams, pathname = location.pathname) => {
      const params = new URLSearchParams();

      if (nextSearchParams.chatId) {
        params.set('chatId', nextSearchParams.chatId);
      }

      if (nextSearchParams.userId) {
        params.set('userId', nextSearchParams.userId);
      }

      history.push({
        pathname,
        search: params.toString() ? `?${params.toString()}` : '',
      });
    },
    [history, location.pathname],
  );

  return {
    searchParams,
    updateSearchParams,
  };
}
